const QUOTED = 'quoted';
const ACCEPTED = 'accepted';
const BOUND = 'bound';
const EXPIRED = 'expired';
const DRAFT = 'draft';
const WITHDRAWN = 'withdrawn';
const SHOULD_NAVIGATE = [ACCEPTED, BOUND, EXPIRED];
const DEFAULT_PAGE = -1;
type BusinessFlow = 'OPC' | 'ONSA' | 'DA' | 'MPS' | undefined;

const GATEWAY_TIMEOUT_STATUS_CODE = 504;
interface BankAccountFieldProps {
    accountNumber: string;
    bankReference: string;
}
interface TimeoutError extends Error {
    isHttpTimeout_Top?: boolean;
}

export {
    QUOTED,
    ACCEPTED,
    BOUND,
    EXPIRED,
    SHOULD_NAVIGATE,
    DEFAULT_PAGE,
    DRAFT,
    WITHDRAWN,
    GATEWAY_TIMEOUT_STATUS_CODE
};

export type { BusinessFlow, TimeoutError, BankAccountFieldProps };
